import React, { Fragment, Suspense, useEffect } from "react";
import { Helmet } from "react-helmet";
import ProductShimmer from "./product.shimmer";
import ErrorView from "../../ErrorView/ErrorView";
import { useProduct } from "../../../Pregrine/RootComponents/Product/useProduct";
import ProductFullDetail from "../../ProductFullDetail/productFullDetail";
import { useLocation } from "react-router-dom";
import ProductSchema from "./ProductSchema";

const CompareWidget = React.lazy(() =>
  import("../../../components/CompareWidget/CompareWidget")
);

const Product = () => {
  const talonProps = useProduct();
  const location = useLocation();
  const currentPath = location.pathname;
  const {
    error,
    loading,
    product,
    ConfigData,
    productSchemaData,
    setProductSchemaData,
  } = talonProps;

  useEffect(() => {
    const existingMetaDescription = document.querySelector(
      'meta[name="description"]'
    );
    if (existingMetaDescription) {
      existingMetaDescription.remove();
    }
  }, []);

  if (error && !loading) {
    return <ErrorView />;
  }

  if (loading || !product) {
    return <ProductShimmer />;
  }

  if (!loading && product === "No Product") {
    return (
      <div className="container">
        <h1 className="text-center" style={{ padding: "0.5rem" }}>
          <span>No Product Found</span>
        </h1>
      </div>
    );
  }

  return (
    <Fragment>
      <Helmet>
        <meta name="robots" content="index, follow" />
        <title>{product.meta_title}</title>
        <meta name="description" content={product.meta_description} />
        <link
          rel="canonical"
          href={`${document.location.origin}${currentPath}`}
        />
      </Helmet>
      {productSchemaData && (
        <ProductSchema
          product={product}
          productSchemaData={productSchemaData}
        />
      )}

      <ProductFullDetail
        product={product}
        ConfigData={ConfigData}
        setProductSchemaData={setProductSchemaData}
      />
      <Suspense fallback={null}>
        <CompareWidget />
      </Suspense>
    </Fragment>
  );
};

export default Product;
